export const globals = {
  adminSessionId: window.crypto.randomUUID() + "_" + Date.now().toString(),
  updateUserCounts: () => {}
};